import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {select, Store} from '@ngrx/store';
import { State } from '../../store/reducer/mitarbeiterverwaltung.reducer';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import {loadAllMitarbeiterStart} from '../../store/actions/getAllMitarbeiter.actions';
import {ZeiterfassungFormdialogNeuComponent} from '../../../Zeiterfassung/components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';
import {MitarbeiterFormdialogComponent} from '../mitarbeiter-form-dialog/mitarbeiter-formdialog.component';
import {loadSalutationsStart} from '../../store/actions/anrede.actions';
import {loadRollenStart} from '../../store/actions/rolle.actions';
import {MitarbeiterItem} from '../../mitarbeiter.model';
import {FirmaFormdialogComponent} from '../firma-form-dialog/firma-formdialog.component';
import {loadBranchenStart} from '../../store/actions/branche.actions';
import {loadFirmaStart} from '../../store/actions/getFirma.actions';
import {FirmaItem} from '../../firma.model';
import {deleteMitarbeiterStart} from '../../store/actions/mitarbeiter-del.actions';
import {reactivateMitarbeiterStart} from "../../store/actions/mitarbeiter-reactivate.actions";
import {loadUserStart} from "../../../landingpage/store/actions/getUser.actions";
import {Router} from "@angular/router";
import {HttpClient} from '@angular/common/http';
import {Security} from '../../../../security';
import {Observable} from 'rxjs';
import {getFilteredMitarbeiterStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getFilteredMitarbeiter.actions';


@Component({
    selector: 'app-mitarbeiterverwaltung-page',
    templateUrl: './mitarbeiterverwaltung-page.component.html',
    styleUrls: ['./mitarbeiterverwaltung-page.component.scss'],
})




export class MitarbeiterverwaltungPageComponent implements OnInit {

  /**
   * Constructor of Addresses page
   *
   * @param store - The store service
   * @param dialog - The dialog service
   */
  // tslint:disable-next-line:max-line-length variable-name
  constructor(
    private _router: Router ,
    private store: Store<{ mitarbeiterverwaltung: State }>,
    private landingStore: Store<{ landingpage: State }>,
    public dialog: MatDialog,
    public http: HttpClient,
    public security: Security) {

    this.$firma = store.pipe(select((state) => state.mitarbeiterverwaltung.firma.item));
    this.$mitarbeiter = store.pipe(select((state) => state.mitarbeiterverwaltung.items));
    this.$personalien = landingStore.pipe(select((state) => state.landingpage.items));

  }
    public showAdd: Observable<boolean>;
    public $mitarbeiter;

    public $personalien;

    public $firma;

    public functionMenuEnabled: boolean;

    /**
     * Executed when the component is initialized
     */
    public ngOnInit(): void {
        this.showAdd = this.security.checkIfAllowed('1001');
        this.functionMenuEnabled = true;
        const firmaId = sessionStorage.getItem('firmaId');
        this.store.dispatch(loadAllMitarbeiterStart({string: firmaId }));
    }

  public editPersonalien(mitarbeiter: MitarbeiterItem): void {
      const dialogRef = this.dialog.open(MitarbeiterFormdialogComponent, {
      data: {
        title: 'pages.mitarbeiterverwaltung.editpersonalien.title',
        submitButtonLabel: 'pages.mitarbeiterverwaltung.editpersonalien.submitButtonLabel',
        cancelButtonLabel: 'pages.mitarbeiterverwaltung.editpersonalien.cancelButtonLabel',
        id: mitarbeiter.id,
        anrede: mitarbeiter.anrede,
        name: mitarbeiter.name,
        vorname: mitarbeiter.vorname,
        email: mitarbeiter.email,
        passwort: mitarbeiter.passwort,
        geburtstag: mitarbeiter.geburtstag,
        mobile: mitarbeiter.mobile,
        rolle: mitarbeiter.rolle,
        ferientage: mitarbeiter.ferientage,
        anstellungprozent: mitarbeiter.anstellungprozent * 100,
        ort: mitarbeiter.ort,
        plz: mitarbeiter.plz,
        str1: mitarbeiter.str1,
        str2: mitarbeiter.str2,
        aktiv: mitarbeiter.aktiv,
        stundenProTag: mitarbeiter.stundenProTag
      },
    });
      dialogRef.afterClosed().subscribe();
  }
  public deletePersonalien(mitarbeiter: MitarbeiterItem): void{
    this.store.dispatch(deleteMitarbeiterStart({item: mitarbeiter}));
  }

  public reactivatePersonalien(mitarbeiter: MitarbeiterItem): void{
    this.store.dispatch(reactivateMitarbeiterStart({item: mitarbeiter}));
  }

  public addMitarbeiter(): void{
    const dialogRef = this.dialog.open(MitarbeiterFormdialogComponent, {
      data: {
        title: 'pages.mitarbeiterverwaltung.addMitarbeiter.title',
        submitButtonLabel: 'pages.mitarbeiterverwaltung.addMitarbeiter.submitButtonLabel',
        cancelButtonLabel: 'pages.mitarbeiterverwaltung.addMitarbeiter.cancelButtonLabel',
        geburtstag: '',
        aktiv: true,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      getFilteredMitarbeiterStart({
        string: sessionStorage.getItem('mitarbeiterSearchString'),
        item: {search: sessionStorage.getItem('mitarbeiterSuche'), deleted: Boolean(sessionStorage.getItem('mitarbeiterDeaktiviert'))}
    });
    });
  }

  public editFirma(firma: FirmaItem): void {
    const dialogRef = this.dialog.open(FirmaFormdialogComponent, {
      data: {
        title: 'pages.mitarbeiterverwaltung.editFirma.title',
        submitButtonLabel: 'pages.mitarbeiterverwaltung.editFirma.submitButtonLabel',
        cancelButtonLabel: 'pages.mitarbeiterverwaltung.editFirma.cancelButtonLabel',
        id: firma.id,
        email: firma.email,
        name: firma.name,
        telefon: firma.telefon,
        arbsol: firma.arbsol,
        branche: firma.branche,
        ort: firma.ort,
        plz: firma.plz,
        str1: firma.str1,
        str2: firma.str2
      },
    });
    dialogRef.afterClosed().subscribe();
  }
}
